module.exports = __webpack_public_path__ + "static/img/collect-yellow.121c27c9.png";